<template>
  <section class="content">
    <div class="box box-info">
      <div class="p-toolbar p-component mb-4">
      <itemSubGroupDialog ref="itemSubGroupdialog"/>
      </div>

        <itemSubGroupList @delete-message="deleteMessage" @edit-group="editItemSubGroup"/>
      </div>
  </section>
</template>
<script>
import itemSubGroupList from './itemSubGroupList.vue'
import itemSubGroupDialog from '../itemDialog/itemSubGroupDialog.vue'
export default {
  name: 'itemgroup',
  data() {
    return {
    }
  },
  methods: {
    editItemSubGroup(data) {
      this.$refs.itemSubGroupdialog.editItemSubGroup(data)
    },
    deleteMessage(value) {
      this.$toast.add({severity: value.messageType, summary: '', detail: value.message, life: 10000})
    }
  },
  components: {
    itemSubGroupList,
    itemSubGroupDialog
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// Itemsubgroup.vue?7020f22f